export enum ArchivedHeatActions {
  SET_DRAFT_START_DATE = 'SET_DRAFT_START_DATE',
  SET_DRAFT_END_DATE = 'SET_DRAFT_END_DATE',
  SET_DRAFT_PAGE = 'SET_DRAFT_PAGE',
  SET_DRAFT_SIZE = 'SET_DRAFT_SIZE',
  RESET_DRAFT_DATE = 'RESET_DRAFT_DATE',
}
